import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Environment } from 'src/environments/environment.model';

import { Crop, GetCropsApiResponse } from '../models';

@Injectable({
  providedIn: 'root',
})
export class CropApiService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  protected baseUrl = this.env.APIM_BASE_URL + '/arable-service/';

  getCrops(): Observable<Crop[]> {
    return this.http
      .get<{ crops: GetCropsApiResponse[] }>(`${this.baseUrl}crop`)
      .pipe(
        map(({ crops }): Crop[] =>
          crops.map((crop) => ({ id: crop.id, name: crop.agrifirmCrop.name })),
        ),
      );
  }
}
